const UINT32_RANGE = 0x100000000

type RandomSource = Pick<Crypto, "getRandomValues">

export function secureRandomInteger(
  minInclusive: number,
  maxInclusive: number,
  randomSource: RandomSource = globalThis.crypto,
) {
  if (
    !Number.isSafeInteger(minInclusive) ||
    !Number.isSafeInteger(maxInclusive) ||
    maxInclusive < minInclusive
  ) {
    throw new RangeError("Random integer bounds must be ordered safe integers.")
  }

  const range = maxInclusive - minInclusive + 1
  if (range > UINT32_RANGE) {
    throw new RangeError("Random integer range cannot exceed 2^32 values.")
  }

  const rejectionLimit = Math.floor(UINT32_RANGE / range) * range
  const randomValue = new Uint32Array(1)

  do {
    randomSource.getRandomValues(randomValue)
  } while (randomValue[0] >= rejectionLimit)

  return minInclusive + (randomValue[0] % range)
}

export function secureRandomIntegers(
  minInclusive: number,
  maxInclusive: number,
  count: number,
  randomSource: RandomSource = globalThis.crypto,
) {
  if (!Number.isSafeInteger(count) || count < 0 || count > 10_000) {
    throw new RangeError("Random integer count must be between 0 and 10,000.")
  }

  return Array.from({ length: count }, () =>
    secureRandomInteger(minInclusive, maxInclusive, randomSource),
  )
}
